import type { Question, QuotaGroup } from '@api/surveys/utilities/types';

export const getDropdownOptions = (items: Item[]) => {
  return items.map((item) => {
    const isQuotaGroup = 'name' in item;
    return {
      label: isQuotaGroup ? item.name : item.text,
      value: item.id,
    };
  });
};

export const getIsPreviewDisabled = (questions?: Question[]) => !questions?.length;

export type Item = Question | QuotaGroup;

export interface PreviewSelection {
  questionId?: number;
  quotaGroupId?: number;
}
